import { trackCarouselClickEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/carousel';

export const cardsCarouselConfig = {
  cardsStoreDataKey: 'carousel1',
  isTitleUnderlined: false,
  hasBackground: false,
  isSmallTitle: true,
  fullWidth: true,
  headingLevel: 3,
  fixedHeight: true,
  hideDescription: true,
};

export const carouselConfig = {
  carouselsStoreDataKey: 'carousel1',
  headingLevel: 4,
  rightChevronIconSrc: '/ccx-files/assets/arrow-right.svg',
  leftChevronIconSrc: '/ccx-files/assets/arrow-left.svg',
  onIndexChange: ({ type, index, isForward }) =>
    trackCarouselClickEvent({
      page: 'article',
      carousel: 'carousel1',
      type,
      index,
      isForward,
    }),
};

export const cardsPerPageMapCarouselConfig = {
  xsmall: 1,
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
};
